var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('z-favorite-addresses',{attrs:{"addresses":_vm.addresses,"type":_vm.type},on:{"selected":function($event){return _vm.$emit('selected', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }